import { useState } from 'react';
import { supabase } from './supabase';
import Home from './pages/Home';
import Merchants from './pages/Merchants';
import Coupons from './pages/Coupons';
import News from './pages/News';
import Rules from './pages/Rules';
import Users from './pages/Users';
import Plans from './pages/Plans';
import ContentBlocks from './pages/ContentBlocks';
import InstagramFeed from './pages/InstagramFeed';
import Testimonials from './pages/Testimonials';
import FeaturedRestaurant from './pages/FeaturedRestaurant';

const GOLD = '#FFC220';
const BLACK = '#111111';

export default function Dashboard() {
  const [activePage, setActivePage] = useState('home');

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  const renderPage = () => {
    switch (activePage) {
      case 'home': return <Home setActivePage={setActivePage} />;
      case 'merchants': return <Merchants />;
      case 'coupons': return <Coupons />;
      case 'news': return <News />;
      case 'rules': return <Rules />;
      case 'users': return <Users />;
      case 'plans': return <Plans />;
      case 'content': return <ContentBlocks />;
      case 'instagram': return <InstagramFeed />;
      case 'testimonials': return <Testimonials />;
      case 'featured': return <FeaturedRestaurant />;
      default: return <Home setActivePage={setActivePage} />;
    }
  };

const navItems = [
    { section: 'OVERVIEW', items: [
      { id: 'home', label: 'Dashboard' },
    ]},
    { section: 'WEBSITE', items: [
      { id: 'content', label: 'Content Blocks' },
      { id: 'merchants', label: 'Merchants' },
      { id: 'coupons', label: 'Coupons' },
      { id: 'featured', label: 'Featured Restaurant' },
      { id: 'instagram', label: 'Instagram Feed' },
      { id: 'testimonials', label: 'Testimonials' },
    ]},
    { section: 'APPS', items: [
      { id: 'users', label: 'Users' },
      { id: 'news', label: 'News' },
      { id: 'plans', label: 'Plans' },
      { id: 'rules', label: 'Program Rules' },
    ]},
  ];

  return (
    <div style={styles.wrap}>

      {/* SIDEBAR */}
      <div style={styles.sidebar}>
        <div style={styles.sidebarLogo}>
          <div style={styles.logoPill}>
            <span style={styles.logoText}>Flatiron Meal Plan</span>
          </div>
          <div style={styles.sidebarTitle}>FMP DASHBOARD</div>
        </div>

        <div style={styles.sidebarNav}>
          {navItems.map((section) => (
            <div key={section.section}>
              <div style={styles.navSectionLabel}>{section.section}</div>
              {section.items.map((item) => (
                <div
                  key={item.id}
                  style={{
                    ...styles.navItem,
                    ...(activePage === item.id ? styles.navItemActive : {}),
                  }}
                  onClick={() => setActivePage(item.id)}
                >
                  <div style={{
                    ...styles.navDot,
                    ...(activePage === item.id ? styles.navDotActive : {}),
                  }} />
                  <span style={{
                    ...styles.navLabel,
                    ...(activePage === item.id ? styles.navLabelActive : {}),
                  }}>{item.label}</span>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div style={styles.sidebarFooter}>
          <div style={styles.userRow}>
            <div style={styles.avatar}>FP</div>
            <span style={styles.username}>Flatiron Admin</span>
          </div>
          <button onClick={handleLogout} style={styles.logoutBtn}>
            Sign Out
          </button>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div style={styles.main}>
        {renderPage()}
      </div>

    </div>
  );
}

const styles = {
  wrap: {
    display: 'flex',
    minHeight: '100vh',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    background: '#f5f5f5',
  },
  sidebar: {
    width: '220px',
    background: BLACK,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    overflowY: 'auto',
  },
  sidebarLogo: {
    padding: '20px 20px 16px',
    borderBottom: '1px solid #222',
  },
  logoPill: {
    background: '#fff',
    borderRadius: '20px',
    padding: '6px 12px',
    display: 'inline-block',
    marginBottom: '8px',
  },
  logoText: {
    color: '#111',
    fontSize: '12px',
    fontWeight: '500',
  },
  sidebarTitle: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: '9px',
    letterSpacing: '1.5px',
  },
  sidebarNav: {
    padding: '8px 0',
    flex: 1,
  },
  navSectionLabel: {
    color: '#444',
    fontSize: '9px',
    letterSpacing: '1.5px',
    padding: '12px 16px 6px',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '9px 16px',
    cursor: 'pointer',
    borderLeft: '2px solid transparent',
  },
  navItemActive: {
    background: '#1a1a1a',
    borderLeft: `2px solid ${GOLD}`,
  },
  navDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    background: '#444',
    flexShrink: 0,
  },
  navDotActive: {
    background: GOLD,
  },
  navLabel: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: '13px',
  },
  navLabelActive: {
    color: GOLD,
  },
  sidebarFooter: {
    padding: '16px',
    borderTop: '1px solid #222',
  },
  userRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '10px',
  },
  avatar: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    background: GOLD,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: BLACK,
    fontSize: '10px',
    fontWeight: '600',
    flexShrink: 0,
  },
  username: {
    color: 'rgba(255,255,255,0.4)',
    fontSize: '11px',
  },
  logoutBtn: {
    width: '100%',
    background: 'transparent',
    border: '1px solid #333',
    borderRadius: '8px',
    color: 'rgba(255,255,255,0.4)',
    fontSize: '12px',
    padding: '8px',
    cursor: 'pointer',
  },
  main: {
    marginLeft: '220px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
};